import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import {
  AddToCartItemPayloadProductArgs,
  AddToCartPayload,
  MutationQuickAddToCartArgs
} from '@hdms/shared/common-types';

import { addToCartPayloadFragment } from './add-to-cart-gql.service';

export type QuickAddToCartInputArgs = MutationQuickAddToCartArgs & AddToCartItemPayloadProductArgs;

export interface QuickAddToCartResponse {
  quickAddToCart: AddToCartPayload;
}

@Injectable({
  providedIn: 'root'
})
export class QuickAddToCartGqlService extends Mutation<QuickAddToCartResponse, QuickAddToCartInputArgs> {
  override document = gql`
    mutation QuickAddToCart($input: QuickAddToCartInput!, $localization: LocalizationInput!) {
      quickAddToCart(input: $input) {
        ...AddToCartProps
      }
    }
    ${addToCartPayloadFragment}
  `;
}
